import type { CompetitiveFilterType } from "../types/common";

export const COMPETITIVE_LANDSCAPE_TABLE_KEY = "CompetitiveLandscapeTable";
export const COMPETITIVE_LANDSCAPE_TABLE_PROPERTY = "Domain";

export const FILTERS_OBJECT: CompetitiveFilterType = {
    domain: {
        action: "contains",
    },
    category: {
        action: "category",
    },
    industryTaxonomy: {
        action: "industryTaxonomy",
    },
};

/**
 * The two industry classifications filter through separate keys, and only one of them is ever served
 * (ADR-0013). Writing either clears the other, so a bookmark made before the account migrated cannot
 * keep filtering by a classification the response no longer carries.
 */
export const INDUSTRY_FILTER_KEYS = ["category", "industryTaxonomy"] as const;

export type IndustryFilterKey = (typeof INDUSTRY_FILTER_KEYS)[number];

export const COMPETITIVE_LANDSCAPE_ROUTE_NAME = "accountreview_website_competitivelandscape";
